export default __webpack_public_path__ + "static/media/Aashique_Ahmed_Iqbal_th.7d0fef8a.png";